import { useEffect, useState } from "react";
import { Navbar, Nav, Form, Button, NavDropdown } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../../contexts/AuthContext";
import MYZNavBar from "./myz-navbar";
import MorkBorgNavBar from "./mork-borg-navbar";
import KidsOnBikesNavBar from "./kids-on-bikes-navbar";
import ForbiddenLandsNavBar from "./forbidden-lands-navbar";
import BITDNavBar from "./bitd-navbar";
import BRNavBar from "./blade-runner-navbar";
import ExquisiteCorpsesNavBar from "./exquisite-corpses-navbar";
import ResourcesNavBar from "./resources-navbar";
import RavenHead from "../../../assets/smoke-raven-avatar.webp";

const NavBar = () => {
  const { currentUser, logout } = useAuth();
  const navigate = useNavigate();
  const [avatarSrc, setAvatarSrc] = useState(RavenHead);

  useEffect(() => {
    if (currentUser?.photoURL) {
      setAvatarSrc(currentUser.photoURL);
      return;
    }
    setAvatarSrc(RavenHead);
  }, [currentUser?.photoURL]);

  const handleLogout = async () => {
    try {
      await logout();
      navigate("/");
    } catch (error) {
      console.error("Failed to log out:", error);
    }
  };
  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="xl"
      sticky="top"
      className="sr-main-navbar"
    >
      <Navbar.Brand href="/">SmokeRaven</Navbar.Brand>

      <Navbar.Toggle aria-controls="basic-navbar-nav" />

      <Navbar.Collapse
        id="basic-navbar-nav"
        className="sr-main-navbar-collapse"
      >
        <Nav className="sr-main-navbar-links">
          <a href="/">
            <img src={RavenHead} alt="SmokeRaven" style={{ maxHeight: 40 }} />
          </a>
          <BITDNavBar />
          <BRNavBar />
          <ForbiddenLandsNavBar />
          <KidsOnBikesNavBar />
          <MorkBorgNavBar />
          <MYZNavBar />
          <ResourcesNavBar />
          <ExquisiteCorpsesNavBar />
          {/*TODO: use other navbar to get submenus: https://www.npmjs.com/package/react-bootstrap-submenu*/}
        </Nav>

        <Form
          inline="true"
          className="d-flex align-items-center mt-3 mt-xl-0 sr-main-navbar-auth"
        >
          {/* <div style={{ marginRight: 20 }}>
            <small>
              <span style={{ color: "white" }}>Discord Channel: </span>
              <a
                style={{
                  fontWeight: 600,
                  color: "white",
                  textDecoration: "underline",
                }}
                href="https://discord.gg/GMxHdxNP5Q"
                rel="noreferrer"
                target="_blank"
              >
                SmokeRaven News
              </a>
            </small>
          </div> */}

          {currentUser ? (
            <NavDropdown
              title={
                <span className="text-white">
                  <img
                    src={avatarSrc}
                    alt="Profile"
                    className="rounded-circle me-2"
                    style={{
                      width: "30px",
                      height: "30px",
                      objectFit: "cover",
                    }}
                    referrerPolicy="no-referrer"
                    onError={() => setAvatarSrc(RavenHead)}
                  />
                  {currentUser.displayName || "User"}
                </span>
              }
              id="user-dropdown"
              align="end"
            >
              <NavDropdown.Item onClick={() => navigate("/dashboard")}>
                Dashboard
              </NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item onClick={handleLogout}>
                Sign Out
              </NavDropdown.Item>
            </NavDropdown>
          ) : (
            <Button
              variant="outline-light"
              size="sm"
              style={{ marginRight: "20px" }}
              onClick={() => navigate("/login")}
            >
              Sign In
            </Button>
          )}
        </Form>
      </Navbar.Collapse>
    </Navbar>
  );
};
export default NavBar;
